export default __webpack_public_path__ + "static/media/imageIcon.4a2f395d.svg";